var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "post-form-index-component" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMainView,
            expression: "isMainView"
          }
        ]
      },
      [
        _c("a", { staticClass: "modal__close" }, [
          _c("i", {
            staticClass: "icon-close",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("PostForm", {
          ref: "PostForm",
          attrs: {
            post_init: _vm.post_init,
            "show-add-link-view": _vm.showAddLinkView,
            "show-search-card-view": _vm.showSearchCardView
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isAddLinksView,
            expression: "isAddLinksView"
          }
        ]
      },
      [
        _c("AddLinks", {
          ref: "AddLinks",
          on: {
            changed: function($event) {
              return _vm.postUpdate({ url_hash: $event })
            },
            close: function($event) {
              _vm.view = "main"
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isSearchCardView,
            expression: "isSearchCardView"
          }
        ]
      },
      [
        _c("SearchCardCollection", {
          on: {
            close: function($event) {
              _vm.view = "main"
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }